import { Grid, Typography } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import React, { useEffect, useState } from 'react'
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import UploadFile from 'components/Common/ElementInForm/UploadFile/UploadFile';
import { Extension } from 'service/CommonFunction/TS_function';
import { DataGridMuiClient } from 'components/Common/Table/DataGridMuiClient';
import { BtnAdd, BtnDelete, BtnSearchOnTable } from 'components/Common/Button';
import { GridColumns } from '@mui/x-data-grid-pro';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';

const CpnStatusVOC = (props) => {
    const {
        form,
        Option,
        DataRowResolve,
        arrFileResolve,
        setarrFileResolve,
        onAddResolve2Table,
        onDeleteArrResolve,
        onClearFileResolve,
        nStatusID,
        sMode,
        setsStatusForm,
        objPermission
    } = props;

    const [IsView, setIsView] = useState(false)

    useEffect(() => {
        setIsView(nStatusID != 0 && (sMode === "view" || objPermission?.Status?.isDisable == true))
    }, [nStatusID,sMode])

    const GotoFilePath = (item) => {
        window.open(item.row?.sFileLink ?? "/");
    }

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 40,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sFileName",
            headerName: "เอกสาร",
            headerAlign: "center",
            flex: 1,
            align: "left",
            resizable: false,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                return (
                    <>
                        <BtnSearchOnTable txt='ดู' onClick={() => { GotoFilePath(item) }} /> &nbsp;&nbsp;&nbsp;
                        <Typography component={"label"} style={{ wordBreak: 'break-word' }}>
                            {item.value}
                        </Typography>
                    </>
                );
            },
        },
        {
            field: "",
            headerName: "",
            headerAlign: "center",
            width: 40,
            align: "center",
            resizable: false,
            disableReorder: true,
            sortable: false,
            renderCell: (item) => {
                return (
                    <>
                        {
                            IsView ? null :
                                <BtnDelete
                                    isCircleWithOutText={true}
                                    onClick={() => { onDeleteArrResolve(item.row) }}
                                />
                        }
                    </>
                );
            },
        },
    ];

    return (
        <>
            <Accordion header={"สถานะใบงาน (ข้อมูลใช้ภายใน)"}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{marginTop:'-20px'}}>
                    <Grid item xs={12} sm={6}>
                        <AutoCompleteSelect
                            name="oStatus"
                            options={Option.lstStatus ?? []}
                            label={"สถานะ"}
                            required={false}
                            onChange={(e) => {
                                if (e) {
                                    setsStatusForm(e.value)
                                }
                                else {
                                    setsStatusForm(null)
                                }
                            }}
                        />
                    </Grid>
                    {
                        form.getValues("oStatus") && (["15", "16"].includes(form.getValues("oStatus").value))
                            ?
                            <Grid item xs={12} >
                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                    <Grid item xs={12} >
                                        <InputCustomLabel
                                            id="sResolveDetail"
                                            name="sResolveDetail"
                                            label="รายละเอียดการแก้ไข"
                                            required={true}
                                            multiline={true}
                                            maxLength={1000}
                                            rows={4}
                                            fullWidth
                                            disabled={IsView}
                                        />
                                    </Grid>
                                    {
                                        IsView ? null :
                                            <Grid item xs={12} >
                                                <UploadFile
                                                    id="sDocFileStatusResolve"
                                                    keyID={7}
                                                    sTitle={"เอกสารแนบ"}
                                                    IsRequired={false}
                                                    arrFile={arrFileResolve || []}
                                                    setarrFile={setarrFileResolve}
                                                    IsFolder={false}
                                                    IsFile={true}
                                                    IsMultiple={false}
                                                    Extension={[...Extension.PDF, ...Extension.Image, ...Extension.Word, ...Extension.Excel, ...Extension.Other]}
                                                    IsDrag={false}
                                                    nLimitFile={10}
                                                    sLimitFile={"MB"}
                                                    onClearFile={onClearFileResolve}
                                                />
                                            </Grid>
                                    }
                                    {/* {
                                        IsView  || arrFileResolve.length == 0 ? null :
                                            <Grid item xs={12} >
                                                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                                    <Grid item>
                                                        <BtnAdd txt={"เพิ่มเอกสาร"} onClick={() => { onAddResolve2Table() }} />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                    } */}
                                    <Grid item xs={12} >
                                        <DataGridMuiClient
                                            isLoading={false}
                                            rows={DataRowResolve}
                                            HiddenToolHead={true}
                                            Columns={dataColumn}
                                            backgroundHeaderCustom={"#004290"}
                                            sxCustomHeader={{ color: '#ffffff' }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            : null
                    }

                </Grid>
            </Accordion>
        </>
    )
}

export default CpnStatusVOC